import { render } from "./ContingentRegistrationPage.vue?vue&type=template&id=1ee4292f&scoped=true"
import script from "./ContingentRegistrationPage.vue?vue&type=script&lang=js"
export * from "./ContingentRegistrationPage.vue?vue&type=script&lang=js"

import "./ContingentRegistrationPage.vue?vue&type=style&index=0&id=1ee4292f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ee4292f"]])

export default __exports__